// extracted by mini-css-extract-plugin
module.exports = {"fastAdd":"StudyTableFastAdd_fastAdd__331jP","button":"StudyTableFastAdd_button__Fsn71","edit":"StudyTableFastAdd_edit__3se6g","skeleton":"StudyTableFastAdd_skeleton__3gpUA"};